import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-xl font-bold capitalize" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "capitalize" }
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "text-xl font-bold capitalize" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "capitalize" }

import CardTemplate from "@/components/template/CardTemplate.vue"
  import BottomModal from "@/components/template/BottomModal.vue"
  interface Details {
    id: string
    name: string
    code?: string
  }

  interface Props {
    type: string
    bat: Details[]
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'BatContainer',
  props: {
    type: null,
    bat: null
  },
  setup(__props: any) {

const props = __props as {
    type: string
    bat: Details[]
  }

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CardTemplate, { class: "mx-3" }, {
    default: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(__props.type), 1),
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.bat.slice(0, 5), (batItem) => {
          return (_openBlock(), _createElementBlock("li", {
            key: `${batItem}_id`,
            class: "flex gap-3 items-center py-2"
          }, [
            _createElementVNode("img", {
              src: `https://assets.workbean.co/${__props.type === 'tech stack' ? 'skill-logos' : __props.type}/${__props.type === 'tech stack' ? batItem.name : batItem.code}.${
            __props.type === 'tech stack' || batItem.name === 'MindNation' ? 'png' : 'svg'
          }`,
              alt: batItem.name.replaceAll('-', ' '),
              class: _normalizeClass(["h-12 w-12 px-2 object-contain object-left", __props.type !== 'tech stack' ? 'dark:invert' : 'invert-0']),
              onerror: "this.onerror=null;this.src='https://assets.workbean.co/error/techstack-error.png';"
            }, null, 10, _hoisted_2),
            _createElementVNode("span", _hoisted_3, _toDisplayString(batItem.name), 1)
          ]))
        }), 128)),
        (props.bat.length > 5)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              id: `${__props.type}_modal`,
              expand: "block",
              class: "opacity-70 underline text-primary-black"
            }, "See more", 8, _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      _createVNode(BottomModal, {
        type: `${__props.type}_modal`
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(__props.type), 1),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.bat, (batItem) => {
              return (_openBlock(), _createElementBlock("li", {
                key: `${batItem}_id`,
                class: "flex gap-3 items-center py-2"
              }, [
                _createElementVNode("img", {
                  src: `https://assets.workbean.co/${__props.type === 'tech stack' ? 'skill-logos' : __props.type}/${__props.type === 'tech stack' ? batItem.name : batItem.code}.${
              __props.type === 'tech stack' || batItem.name === 'MindNation' ? 'png' : 'svg'
            }`,
                  alt: batItem.name.replaceAll('-', ' '),
                  class: _normalizeClass(["h-12 w-12 px-2 object-contain object-left", __props.type !== 'tech stack' ? 'dark:invert' : 'invert-0']),
                  onerror: "this.onerror=null;this.src='https://assets.workbean.co/error/techstack-error.png';"
                }, null, 10, _hoisted_6),
                _createElementVNode("span", _hoisted_7, _toDisplayString(batItem.name), 1)
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["type"])
    ]),
    _: 1
  }))
}
}

})